import config from "../config"
const baseUrl = config.base_url + "work_code/perception/"
export default {
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    update: {
        url: baseUrl + "update",
        type: "post",
    },
    page: {
        url: baseUrl + "page/{limit}/{page}",
        type: "get",
    },
    listByProcessStatus: {
        url: baseUrl + "listByProcessStatus",
        type: "get",
    },
    countByProcessStatus: {
        url: baseUrl + "countByProcessStatus",
        type: "get",
    },
    updateProcessStatus: {
        url: baseUrl + "updateProcessStatus",
        type: "get",
    },
    batchUpdateImageStatus: {
        url: baseUrl + "batchUpdateImageStatus",
        type: "post",
    },
    resetImageResFilename: {
        url: baseUrl + "resetImageResFilename",
        type: "post",
    }
}
